import React, { useRef, useEffect } from "react";
import styles from "./Video.module.css";

const Video = ({ handleCloseVideo }: { handleCloseVideo: () => void }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const playVideo = () => {
      if (videoRef.current) {
        videoRef.current.volume = 1; // Ensure volume is enabled
        const playPromise = videoRef.current.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("Autoplay successful");
              document.removeEventListener("click", playVideo);
              document.removeEventListener("keydown", playVideo);
              document.removeEventListener("touchstart", playVideo);
            })
            .catch((error) => {
              console.warn(
                "Autoplay blocked, waiting for user interaction",
                error
              );
            });
        }
      }
    };

    // Attempt to play immediately
    playVideo();

    // Attach event listeners for user interaction
    document.addEventListener("click", playVideo);
    document.addEventListener("keydown", playVideo);
    document.addEventListener("touchstart", playVideo);

    return () => {
      document.removeEventListener("click", playVideo);
      document.removeEventListener("keydown", playVideo);
      document.removeEventListener("touchstart", playVideo);
    };
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.background}></div>
      <div className={styles.box}>
        <video src="/videos/end.mp4" autoPlay ref={videoRef} />
        <button onClick={handleCloseVideo} className={styles.closeButton}>
          <img src="/images/closeCircle.svg" alt="Close" />
        </button>
      </div>
    </div>
  );
};

export default Video;
